import React from 'react';

import { List, ListItem, Typography} from '@mui/material';
import { CardActions, CardContent, CardMedia, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const Free2025Card = ({ plan, sx }) => {
    return (
        <>
            <CardMedia
                component="img"
                height="140"
                image="/images/subscriptionPlanStub.jpg"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Бесплатный
                </Typography>
                <List>
                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: '1.3em' }}>
                        <ListItem>Хранение всей истории ваших данных</ListItem>
                        <ListItem>Отображение динамики</ListItem>
                    </Typography>
                </List>
            </CardContent>
            <CardActions sx={{
                flex: 1,
                display: 'flex',
                flexFlow: 'column nowrap',
                alignItems: 'center',
                justifyContent: 'flex-end',
            }}>
                <Typography variant="body1" sx={{
                    color: t => t.palette.success.main,
                    textAlign: 'center',
                    mb: 1,
                }}>
                    Бесплатно
                </Typography>
                <Typography variant="body1" sx={{
                    color: 'green',
                    textAlign: 'center',
                    mb: 1,
                }}>
                    <CheckCircleIcon sx={{
                        position: 'relative',
                        top: '0.3em',
                        mr: 1
                    }}/> всегда активен
                </Typography>
            </CardActions>
        </>
    )
}
